import { download } from '@util/xhrAPI'

const extensions = {
  pdf: {
    fileType: 'application/pdf',
    fileExetnsion: '.pdf'
  },
  csv: {
    fileType: 'text/plain;charset=utf-8',
    fileExetnsion: '.csv'
  },
  zip: {
    fileType: 'application/zip',
    fileExetnsion: '.zip'
  }
}

const useDownloadFile = () => {
  const downloadFile = (fileUrl, fileName, extension, onProgress = false) => {
    const { fileType, fileExetnsion } = extensions[extension]
    return download(fileUrl, onProgress).then(response => {
      const blob = new Blob([response], { type: fileType })
      const url = window.URL.createObjectURL(blob)
      const tempLink = document.createElement("a")
      tempLink.href = url
      tempLink.setAttribute(
        "download",
        `${fileName}${fileExetnsion}`
      )
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      window.URL.revokeObjectURL(url)
    })
  }

  return downloadFile
}

export default useDownloadFile